import { studioApiUrl, studioAuthHeaders } from '@/pages/DataDimensionStudio/studioApi';

export type CameraCard = {
  cameraId: string;
  name: string;
  siteId: string;
  siteName: string;
  facilityId: string;
  facilityName: string;
  clipCount: number;
  latestEventTime: string | null;
  posterEventId: string | null;
};

export type LibraryResponse = {
  sites: { siteId: string; siteName: string; cameras: CameraCard[] }[];
  facilities: { facilityId: string; facilityName: string; cameras: CameraCard[] }[];
};

export type CameraActivity = {
  direction: 'outbound' | 'inbound';
  action: string;
  occurredAt: string;
  originSystem: string;
  counterpartySystem: string;
  sourceRecordId: string;
  referenceId: string;
  summary: string;
  details: { label: string; value: string }[];
};

export type ClipMedia = { key: string; kind: string; note: string; mode: 'video' | 'image' | 'text'; count: number };

export type ClipActivity = { type: string; at: string | null; userName: string; details: string };

export type ClipDetail = {
  eventId: string;
  eventTime: string | null;
  reviewedAt: string | null;
  severity: string;
  status: string;
  reviewFlowStatus: string;
  needsReview: boolean | null;
  isReviewed: boolean | null;
  isCoached: boolean | null;
  isBooked: boolean | null;
  tag: string;
  cameraId: string;
  cameraName: string;
  cameraStatus: string;
  videoLength: number;
  storageTier: string;
  videoCreatedTime: string | null;
  videoDeleted: boolean | null;
  siteId: string;
  siteName: string;
  facilityId: string;
  facilityName: string;
  companyName: string;
  entityType: string;
  eventHash: string;
  isNew: boolean | null;
  policyId: string;
  policyName: string;
  policyDescription: string;
  secondaryPolicies: { name: string; severity: string }[];
  dynamicRisk: {
    severity: string;
    description: string;
    policyName: string;
    startSec: number | null;
    endSec: number | null;
    factors: { description: string; severity: string }[];
  } | null;
  media: ClipMedia[];
  activity: ClipActivity[];
  comments: string[];
  objects: string[];
  customTags: string[];
  eventTimeThreshold: string;
};

export type ClipCard = {
  eventId: string;
  eventTime: string | null;
  eventHash: string;
  severity: string;
  videoLength: number;
  hasPoster: boolean;
  hasBlurredVideo: boolean;
};

export function camerasUrl(path: string) {
  return studioApiUrl(path);
}

export function camerasHeaders() {
  return studioAuthHeaders();
}

export function formatWhen(value?: string | null) {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  return date.toLocaleString(undefined, { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' });
}
